import { mapperEventSpeaker } from '../event-speaker/mapper-event-speaker'
import type { MapperImageOptions } from '#layers/core/types'

/**
 * BlockEventBlockSpeakers
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

export const mapperEventBlockSpeakers = (data: any, imageOptions: MapperImageOptions) => {
  if (!data) {
    return null
  }

  return {
    id: data.sys?.id || '',
    contentType: data.contentType,
    title: data.title || '',
    description: data.blockSpeakersDescription || {},
    items: data.eventSpeakersCollection?.items?.map((item) => mapperEventSpeaker(item, imageOptions)) || []
  }
}
